import Loadable from 'react-loadable'
import globalRoutes from './global'
import yaaroRoutes from './yaaro'
console.log(123)

export const routes = [
    // 首页
    {
        path: '/',
        exact: true,
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: "page-Home" */ '../pages/home_yaaro'),
            loading: () => null,
        }),
    },
]

const allRoutes = routes
  .concat(globalRoutes, yaaroRoutes)
  .concat({
    path: '',
    exact: false,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-NotFound" */ '../pages/404'),
      loading: () => null,
    }),
  })

export default store => allRoutes
